import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LiveMatchSection from './components/LiveMatchSection';
import CategoryNav from './components/CategoryNav';
import NewsSection from './components/NewsSection';
import DataSection from './components/DataSection';
import CommunitySection from './components/CommunitySection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="九游体育 - 专业体育赛事平台 | 赛事直播、数据分析、体育资讯"
        description="九游体育是您最值得信赖的专业体育赛事平台，汇聚全球顶级赛事直播、体育资讯、赛事数据分析及互动社区。覆盖足球、篮球、网球等多项运动，为体育爱好者提供一站式体育娱乐体验。"
        keywords="九游体育,九游体育赛事直播,九游体育官网,九游体育数据分析,九游体育足球,九游体育篮球,九游体育手机版"
        canonicalUrl="https://www.jiuyou-sports.com/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九游体育 - 专业体育赛事平台',
          description: '九游体育是专业体育赛事平台，汇聚全球顶级赛事直播、体育资讯、赛事数据分析及互动社区。',
          url: 'https://www.jiuyou-sports.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '九游体育',
            url: 'https://www.jiuyou-sports.com/',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <LiveMatchSection />
          <CategoryNav />
          <NewsSection />
          <DataSection />
          <CommunitySection />
        </main>
        <Footer />
      </div>
    </>
  );
}